import React, { useState, useCallback, useEffect, Fragment } from "react";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { PageHeader } from '../../../Common';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';


const useStyles = makeStyles((theme) => ({
    root: {
        fontSize: 10,
    },
    title: {
        fontSize: 12,
    },
    btncolor: {
        background: '#10BA57'
    },
    btnroot: {
        backgroundColor: '#10BA57',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: '30px',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        "&:hover": {
            //you want this to be the same as the backgroundColor above
            backgroundColor: "#049C44"
        }

    },
    card: {
        alignContent: 'center'
    },
    table: {
        minWidth: 650,
    },
}));

export function ViewRecord(props) {

    const classes = useStyles();
    const [tagDetails, setTagDetails] = useState({
        routeCode: "",
        date: "",
        cardNo: "",
        supplierRegNo: "",
        grossWeight: "",
        routeName: "",
        newDate: "",
        customerNo: "",
        deductions: "",
        actualAmount: "",
        netAmount: "",
        productDeduction: []
    });

    const [newTagDetails, setNewTagDetails] = useState({
        routeCode: "",
        date: "",
        cardNo: "",
        supplierRegNo: "",
        grossWeight: "",
        routeName: "",
        newDate: "",
        customerNo: "",
        deductions: "",
        actualAmount: "",
        netAmount: "",
        oldDeduction: [],
        newDeduction: []
    });
    useEffect(() => {

        if (props.oldTags != null) {
            setTagDetails(props.oldTags);
        }
    }, [props.oldTags]);

    useEffect(() => {
        if (props.tagDetails != null) {
            setNewTagDetails(props.tagDetails);
        }
    }, [props.tagDetails]);




    return (
        <Fragment>
            <Card className={classes.root}>
                <form className={classes.root} noValidate autoComplete="off">
                    <CardContent>
                        <PageHeader
                            title={"View Tag Information Comparison"}
                            isButtonEnable={false}
                            buttonText="Back to Listing"
                            path="/leafamendRequest"
                        />

                        <Grid container spacing={3}>
                            <Grid item xs={12} >


                                <Card>
                                    <CardContent>

                                        <br />
                                        <Grid container spacing={3}>
                                            <Grid item xs={6} >
                                                <Grid container spacing={3}>
                                                    <Chip
                                                        label="Before Amendment"
                                                        className={classes.chip}
                                                    />
                                                </Grid>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="body1" >
                                                            Date *:
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField

                                                            id="fromDate"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            type="date"
                                                            disabled={true}
                                                            value={((tagDetails.newDate).split("T"))[0]}

                                                        >

                                                        </TextField>
                                                    </Grid>
                                                </Grid>


                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="body1" >
                                                            Card No:
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="cardNo"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={tagDetails.cardNumber}

                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>


                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="body1" >
                                                            Actual Weight :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="opreationID"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={tagDetails.actualAmount}

                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="body1" >
                                                            Gross Weight :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="opreationID"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={tagDetails.grossAmount}

                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="body1" >
                                                            Net Weight :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="opreationID"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={tagDetails.netAmount}

                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="body1" >
                                                            Deductions :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <Paper component="ul" className={classes.rootpaper}>
                                                            {tagDetails.productDeduction.map((data) => {
                                                                let icon;
                                                                return (
                                                                    <li key={data.productDeductionID}>
                                                                        <Chip
                                                                            icon={icon}
                                                                            label={data.deductionTypeName + ":" + data.deductionAmount}
                                                                            className={classes.chip}
                                                                        />
                                                                    </li>
                                                                );
                                                            })}
                                                        </Paper>
                                                    </Grid>
                                                </Grid>

                                            </Grid>
                                            <Grid item xs={6} >

                                                <Grid container spacing={3}>
                                                    <Chip
                                                        label="After Amendment"
                                                        className={classes.chip}
                                                    />
                                                </Grid>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="body1" >
                                                            Date *:
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField

                                                            id="fromDate"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            type="date"
                                                            disabled={true}
                                                            value={((newTagDetails.newDate).split("T"))[0]}

                                                        >

                                                        </TextField>
                                                    </Grid>
                                                </Grid>


                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="body1" >
                                                            Card No:
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="cardNo"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={newTagDetails.cardNumber}

                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>


                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="body1" >
                                                            Actual Weight :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="opreationID"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={newTagDetails.actualAmount}

                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="body1" >
                                                            Gross Weight :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="opreationID"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={newTagDetails.grossAmount}

                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="body1" >
                                                            Net Weight :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <TextField
                                                            id="opreationID"
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={true}
                                                            value={newTagDetails.netAmount}

                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <Typography variant="body1" >
                                                            Deductions :
                                                    </Typography>
                                                    </Grid>

                                                    <Grid item xs={6}>
                                                        <Paper component="ul" className={classes.rootpaper}>
                                                            {newTagDetails.oldDeduction.map((data) => {
                                                                let icon;
                                                                return (
                                                                    <li key={data.productDeductionID}>
                                                                        <Chip
                                                                            label={data.deductionTypeName + ":" + data.deductionAmount}
                                                                            className={classes.chip}
                                                                        />
                                                                    </li>
                                                                );
                                                            })}
                                                            {newTagDetails.newDeduction.map((data) => {
                                                                let icon;
                                                                return (
                                                                    <li key={data.productDeductionID}>
                                                                        <Chip
                                                                            label={data.deductionTypeName + ":" + data.deductionAmount}
                                                                            className={classes.chip}
                                                                        />
                                                                    </li>
                                                                );
                                                            })}
                                                        </Paper>
                                                    </Grid>
                                                </Grid>



                                            </Grid>



                                        </Grid>
                                    </CardContent>
                                    <CardActions className={classes.card} alignContent={'right'}>

                                    </CardActions>
                                </Card>

                            </Grid>
                        </Grid>
                    </CardContent>

                </form>
            </Card>

        </Fragment>
    );
}
